var _style, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterJobsInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97 97",
    style: {
      enableBackground: "new 0 0 97 97"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3A4F50;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,32.1h12.1V24H28.4V32.1z M40.5,32.1c2.1,0.1,3.9-1.5,4-3.6c0-0.2,0-0.3,0-0.5c0.1-2.1-1.5-3.9-3.6-4 c-0.2,0-0.3,0-0.5,0L40.5,32.1L40.5,32.1z M28.4,24c-2.1-0.1-3.9,1.5-4,3.6c0,0.2,0,0.3,0,0.5c-0.1,2.1,1.5,3.9,3.6,4 c0.2,0,0.3,0,0.5,0L28.4,24L28.4,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,52.3h40.3v-8.1H28.4V52.3z M68.7,52.3c2.2,0,4-1.8,4-4c0-2.2-1.8-4-4-4V52.3z M28.4,44.2 c-2.2,0-4,1.8-4,4s1.8,4,4,4V44.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.6-0.2c-40,0-48.4,8.5-48.4,48.4s8.5,48.4,48.4,48.4c4,0.1,8.1-0.1,12.1-0.4C86.5,94.6,95,86.2,96.6,60.3 c0.3-4,0.5-8.1,0.4-12.1C97,8.3,88.5-0.2,48.6-0.2z M82,81.7c-2.8,2.8-7.7,5.2-17.4,6.1v-1.2c0.5-5.7,2.9-11.1,6.9-15.3 c4.3-3.7,9.7-6.1,15.3-6.9h1.2C87.3,73.6,84.9,78.9,82,81.7z M88.9,56.3c-1-0.1-1.9,0.1-2.8,0.4c-7.5,0.7-14.6,3.8-20.2,8.9 c-5.1,5.6-8.2,12.7-8.9,20.2c0,0.8-0.4,2-0.4,2.8h-8.1C41,88.8,33.4,88.3,25.9,87c-4.1-0.5-8-2.3-10.9-5.2c-2.8-3-4.6-6.8-5.2-10.9 c-1.3-7.5-1.8-15-1.6-22.6c-0.2-7.6,0.3-15.1,1.6-22.6c0.6-4.1,2.5-7.9,5.2-10.9c3-2.8,6.8-4.6,10.9-5.2c7.5-1.3,15-1.8,22.6-1.6 c7.6-0.2,15.1,0.3,22.6,1.6c4.1,0.5,8,2.3,10.9,5.2c2.8,3,4.6,6.8,5.2,10.9c1.3,7.5,1.8,15,1.6,22.6L88.9,56.3L88.9,56.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterJobsInactive);
export default __webpack_public_path__ + "static/media/FooterJobsInactive.4939ac5200305d10884ff8b9ef92ff7c.svg";
export { ForwardRef as ReactComponent };